import axios from 'axios';


//axios.defaults.baseURL = 'https://saux-api.centralexpress.info';
//axios.defaults.baseURL = 'http://192.168.8.200:8000';
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || 'http://192.168.8.200:8000';
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;

  //codigo mejorado para errores de login y redireccionamiento
 axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (
      error &&
      error.response &&
      error.response.status === 401 &&
      window.location.pathname !== "/"
    ) {
      // Lee el mensaje del backend
      const msg = error.response.data?.detail || "";
      if ( 
        msg === "No se Pudo Validar la Informacion de Inicio"
      ) {
        // Solo si es por token, cierra sesión
        localStorage.removeItem('access_token');
        window.location.href = "/";
      } else{
        // Si es por permisos, solo muestra alerta del mensaje la data del backend si no tiene nada en detail muestra el mensaje de error
        const errorMessage = msg || "No tienes permisos para realizar esta acción.";
        console.error(errorMessage);
        //alert("No tienes permisos para realizar esta acción.");
      }
    }
    return Promise.reject(error);
  }
);